import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const IMAGE_WIDTH = 62;
const IMAGE_WIDTH_DESKTOP = 85;
const IMAGE_HEIGHT = 80;
const IMAGE_HEIGHT_DESKTOP = 106;

const style = (isDesktop: boolean) => {
  const { borderRadius3, borderWidth2, colorBorderInput } = theme();

  return StyleSheet.create({
    container: {
      borderRadius: borderRadius3,
      overflow: "hidden",
      borderWidth: borderWidth2,
      borderColor: colorBorderInput,
    },
    media: {
      height: isDesktop ? IMAGE_HEIGHT_DESKTOP : IMAGE_HEIGHT,
      width: isDesktop ? IMAGE_WIDTH_DESKTOP : IMAGE_WIDTH,
    },
  });
};

export { style, IMAGE_WIDTH };
